import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

const heartBeatCart = async (
  cartTag: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(M3_API(cartTag).HEARTBEAT_CART, {
    cartTag,
  });
};

export default heartBeatCart;
